import { KeyValuePair } from '@app/core/models/keyValuePair';

class ExportTypes {
  Page = { key: "page", value: 'Huidige pagina' };
  All = { key: "current", value: 'Volledig' };
}
const exportTypes = new ExportTypes();
const keyValuePairs: Array<KeyValuePair> = [
    exportTypes.Page,
    exportTypes.All
];

export {
    exportTypes,
    keyValuePairs
};
